import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import {
  CanvasArgs,
  CanvasBaseCommand,
  CanvasCommandType,
  CanvasCommandVariant,
} from './canvas-command.model'

export interface DeleteAllTracesArgs extends CanvasArgs {
  /** Client-side delegate that deletes all traces. */
  action?: () => void
}

export class DeleteAllTracesCommand extends CanvasBaseCommand<DeleteAllTracesArgs> {
  readonly id = 'delete-all-traces'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'auto_stories'
  override label = 'Delete all'
  override tooltip = 'Delete all traces'
  override readonly variant: CanvasCommandVariant = 'button'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: DeleteAllTracesArgs): boolean {
    return !!args?.hasTraces
  }

  protected doExecute(args?: DeleteAllTracesArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
